export const DEVOPS_NAV = [
    { id: 'services', label: 'Услуги' },
    { id: 'process', label: 'Как работаем' },
    { id: 'skip', label: 'Не берём' },
    { id: 'lead', label: 'Заявка' },
];

export const DEVOPS_HERO_STEPS = [
    {
        num: '01',
        title: 'Диагностика контура',
        text: 'Смотрим, что уже стоит: кластер, CI, секреты, наблюдаемость.',
    },
    {
        num: '02',
        title: 'Согласованный список работ',
        text: 'Не абонемент «вообще DevOps», а конкретный контур и зона ответственности.',
    },
    {
        num: '03',
        title: 'Договор от ООО «Битапл»',
        text: 'Разовый проект или регулярное сопровождение. Счета и акты — от юрлица.',
    },
];

export const DEVOPS_AUDIENCE = {
    yes: {
        title: 'Команды с продуктом, без выделенного DevOps',
        intro:
            'Продуктовые и сервисные IT-команды 5–50 человек: приложение уже есть, контур собран «на коленке» или держится одним человеком.',
        items: [
            'Настроить Kubernetes в Yandex Cloud, Selectel или on-prem',
            'Собрать CI/CD на GitLab и реестр образов',
            'Переехать в облако или взять прод на сопровождение',
        ],
    },
    no: {
        title: 'Не закрываем чужую категорию «под ключ»',
        intro:
            'Берём контур, который сами умеем держать в проде. Остальное — честный отказ, а не обещание в рекламе.',
        items: [
            'Заказы «сделайте сайт» и администрирование Windows-парка',
            'Позиция «официальный партнёр Яндекса»',
            'Абонемент без зоны ответственности и без списка работ',
        ],
    },
};

export const DEVOPS_SERVICES = [
    {
        title: 'Kubernetes',
        text: 'Установка, обновление и сопровождение кластеров в Yandex Cloud, Selectel и on-prem.',
    },
    {
        title: 'CI/CD',
        text: 'GitLab, пайплайны сборки и деплоя, реестр контейнерных образов.',
    },
    {
        title: 'Облако',
        text: 'Сети, DNS, TLS-сертификаты, секреты и Terraform в Yandex Cloud.',
    },
    {
        title: 'Наблюдаемость',
        text: 'Метрики, логи и алерты: Prometheus / VictoriaMetrics, Grafana, Loki.',
    },
    {
        title: 'Безопасный контур',
        text: 'Секреты, VPN, Ingress / Gateway API, hardened-образы контейнеров.',
    },
    {
        title: 'Сопровождение прода',
        text: 'Обновления, разбор инцидентов, бэкапы и описание контура.',
    },
];

export const DEVOPS_PROCESS = [
    {
        num: '01',
        title: 'Заявка',
        text: 'Коротко: что за продукт, где сейчас крутится, какая боль.',
    },
    {
        num: '02',
        title: 'Диагностика',
        text: 'Смотрим контур. Фиксируем, что берём и чего не обещаем.',
    },
    {
        num: '03',
        title: 'Список работ',
        text: 'Согласованный объём: проект или регулярное сопровождение.',
    },
    {
        num: '04',
        title: 'Договор ООО',
        text: 'Счета и акты от ООО «Битапл». Удалённо, юрадрес — Москва.',
    },
];
